import { api } from './NetworkUtility';
import { logError } from './ErrorService';

export const getCompanies = async (callbackHandler, callbackErrorHandler) => {
    const url = '/admin/getCompanyRegistrations';
    return api.get(url)
        .then(response => {
            if (response?.data?.companyRegistrations && response?.data?.companyRegistrations.length) {
                return response.data.companyRegistrations;
            } else {
                return Promise.reject("No company registration data");
            }
        })
        .then(data => {
            callbackHandler(data);
        })
        .catch(function (error) {
            //navigate hook does not work here, using window.location to redirect
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?u";
                });
            } else {
                callbackErrorHandler(error);
            }
        });
}

export const registerCompany = async (company) => {
    const url = `admin/registerCompany`;
    const request = {
        "companyName": company.companyName,
        "companyNumber": company.companyNumber
    }

    // errors will be handled by component 
    return api.post(url, request).then(response => response.data);
}

export const updateRegisteredCompany = async (company) => {
    const url = `admin/updateRegisteredCompany`;
    const request = {
        "companyName": company.companyName,
        "companyNumber": company.companyNumber,
        "uuid": company.uuid
    }

    // errors will be handled by component 
    return api.put(url, request).then(response => response.data);
}

export const getRegisteredCompany = async (uuid, callbackHandler) => {
    const url = `/admin/getRegisteredCompany/${uuid}`;
    api.get(url)
        .then(response => {
            return response.data;
        })
        .then(data => {
            callbackHandler(data)
        })
        .catch(function (error) {
            //navigate hook does not work here, using window.location to redirect
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?su";
                });
            } else {
                callbackHandler(null);
            }
        });
}
